module.exports = __webpack_public_path__ + "img/cut.fb35882.png";